import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import MarketGroupDto from '@core/mappers/struct/dtos/MarketGroupDto';
import MarketGroupInfo from '@models/struct/MarketGroupInfo';

export default class MarketGroupMapper extends AbstractMapper<MarketGroupDto, MarketGroupInfo> {
    createTargetObject(dto: MarketGroupDto): MarketGroupInfo {
        return {
            id: dto.id,
            name: dto.name,
            order: dto.order,
            sportId: dto.sportId,
            // TODO betGroups shouldn't be null,  https://axilis.atlassian.net/browse/TRADE-968
            marketIds: dto.betGroups !== null ? new Set(dto.betGroups) : new Set(),
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/struct/MarketGroupMapper.ts